import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProductDetailInfosInput, ProductLineEmitter } from "../product-detail-infos-input/product-detail-infos-input";
import { ProductDetailInfosTextarea } from "../product-detail-infos-textarea/product-detail-infos-textarea";
import { Product } from '@app/core/interfaces';
import { TabStates } from '../product-detail/product-detail';
import { BaseComponent } from '@app/core/bases';
import { ProductService } from '@app/core/services';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-product-detail-infos',
  imports: [ProductDetailInfosInput, ProductDetailInfosTextarea, ProgressSpinnerModule],
  templateUrl: './product-detail-infos.html'
})
export class ProductDetailInfos extends BaseComponent implements OnChanges, OnInit {
  @Input() product!: Product;
  @Output() productChange: EventEmitter<Product> = new EventEmitter<Product>();

  @Input() tabStates!: TabStates[];
  @Output() tabStatesChange: EventEmitter<TabStates[]> = new EventEmitter<TabStates[]>();
  
  @Input() tabIndex!: number;

  isLoadingData: boolean = true;
  isSendingData: boolean = false;

  lineActivities: ProductLineEmitter[] = [];

  isSubCategoryDisabled: boolean = true;
  subCategoryFilter: { [x: string]: string | number } = {};

  constructor(
    private productService: ProductService
  ) {
    super();
  }

  ngOnInit(): void {
    const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
    if (tab.active && !tab.loaded) {
      this.getProductInfos();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabStates']) {
      const tab: TabStates = this.tabStates.find(state => state.index === this.tabIndex) as TabStates
      if (tab.active && !tab.loaded) {
        this.getProductInfos();
      }
    }
  }
  
  getProductInfos(): void {
    this.apiCall$?.unsubscribe();
    this.apiCall$ = this.productService
      .get(this.product.id, {fields: {produits: 'marque,gamme,reference,categorie,sous_categorie,couts_comptables,description,commentaire,document_url'}})
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data) => {
          this.product = { ...this.product, ...data };
          this.customRequirementHandler();
          this.tabStates.map((state: TabStates) => {
            if (state.index === this.tabIndex)
              state.loaded = true
          });
        },
        complete: () => {
          this.apiCall$?.unsubscribe();
          this.productChange.emit(this.product);
          this.isLoadingData = false;
        }
      });
  }

  sendingDataHandler(event: ProductLineEmitter) {
    const index = this.lineActivities.findIndex(line => line.property === event.property);
    if (index >= 0) this.lineActivities[index] = event;
    else this.lineActivities.push(event);

    if (event.message)
      this.toastService.add(event.message);

    this.customRequirementHandler();

    this.productChange.emit(this.product);
  }

  isLineSendingData(): boolean {
    return this.lineActivities.some(line => line.isSendingData === true);
  }

  customRequirementHandler(): void {
    if (this.product?.categorie?.id) this.isSubCategoryDisabled = false;
    else this.isSubCategoryDisabled = true;

    if (!this.isSubCategoryDisabled && this.product.categorie?.id)
      this.subCategoryFilter = {categorie_id: this.product.categorie.id}
  }
}
